import { DialogTitle } from '@radix-ui/react-dialog';
import React, { useEffect, useState } from 'react';

import CreateShipmentTabForm, { CreateShipmentListTabFormData } from '@/components/modules/shipment/tabs/form';
import { ShipmentTabsShare } from '@/components/modules/shipment/tabs/share';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { UserMessage } from '@/components/ui/user-message';
import { SavedItemModel } from '@/lib/models/saved-item/types';

export interface TabsDialogProps {
  isOpen: boolean;
  onOpenChange: (value: boolean) => void;
  onSubmit: (data: CreateShipmentListTabFormData) => void;
  savedItem?: SavedItemModel;
}

const TabsEditDialog = ({ isOpen, onOpenChange, onSubmit, savedItem }: TabsDialogProps) => {
  const [error, setError] = useState<string>();

  const handleSubmit = async (data: CreateShipmentListTabFormData) => {
    setError(undefined);
    try {
      await onSubmit(data);
    } catch (e: any) {
      setError(e.message);
    }
  };

  useEffect(() => {
    if (!isOpen) {
      setError(undefined);
    }
  }, [isOpen]);

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent onClose={() => onOpenChange(false)}>
        <DialogTitle className="mb-2 text-md font-medium leading-snug">
          {savedItem ? 'Update' : 'Save new'} view
        </DialogTitle>
        {error ? <UserMessage className="!mb-2 !mt-0" heading={error} noIcon variant="error" /> : null}
        <div className="space-y-4">
          <CreateShipmentTabForm onSubmit={handleSubmit} initialValue={savedItem || { label: '' }} />
          {savedItem?.id ? (
            <>
              <hr className="border-dashed border-border-grey" />
              <ShipmentTabsShare savedItemId={savedItem.id} />
            </>
          ) : null}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export { TabsEditDialog };
